export function attachSlashFxDebugHandle(game) {
  if (typeof window === 'undefined') return;
  window.__slashFxDebug = game._slashFxDebug;
}

export function attachSeedDebugHandle(game) {
  if (typeof window === 'undefined') return;
  window.__seedDebug = {
    get: () => ({
      runMode: game.runMode,
      state: game.state,
      roomIndex: game.roomIndex,
      roomNumber: game.roomIndex + 1,
      sessionSeed: game._sessionSeed >>> 0,
      activeRoomSeed: game._lastRoomSeed >>> 0,
      roomDebug: game.room?.getDebugInfo?.() || null,
    }),
    restartRunWithSeed: (seed) => game.startRun(Number(seed) >>> 0),
    restartSandboxWithSeed: (seed) => game.startSandbox(Number(seed) >>> 0),
  };
}
